'use client';

import { c as _c } from "react/compiler-runtime";
import Bugsnag from '@bugsnag/js';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useEffect } from 'react';
import { ErrorView } from '@/app/[locale]/_components/ErrorView';
import useNotFoundData from '@/hooks/useNotFoundData';
import type { AppLocale } from '@/types/general';
interface Props {
  readonly error: Error;
  readonly locale: AppLocale;
}
const queryClient = new QueryClient();
function ErrorContent(t0) {
  const $ = _c(7);
  const {
    error,
    locale
  } = t0;
  let t1;
  let t2;
  if ($[0] !== error) {
    t1 = () => {
      Bugsnag.notify(error);
    };
    t2 = [error];
    $[0] = error;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== locale) {
    t3 = {
      locale
    };
    $[3] = locale;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const {
    data
  } = useNotFoundData(t3);
  const t4 = data?.data;
  let t5;
  if ($[5] !== t4) {
    t5 = <ErrorView data={t4} disableTopMargin={true} />;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}
export default function Err(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <QueryClientProvider client={queryClient}><ErrorContent {...props} /></QueryClientProvider>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}